import React from "react";

function DoorReporting() {
    return (
        <div>
            <h2>Incident Reporting & Record Keeping</h2>
            <p>
                Accurate and timely reporting is essential for legal protection, accountability, and improving safety procedures. This module covers how to document incidents professionally and in compliance with industry standards.
            </p>

            <h3>Why Reporting Matters</h3>
            <ul>
                <li>Provides a legal record of events</li>
                <li>Supports investigations and disciplinary action</li>
                <li>Protects staff and the organization from liability</li>
                <li>Helps identify patterns and improve safety protocols</li>
            </ul>

            <h3>What to Include in an Incident Report</h3>
            <ul>
                <li>Date, time, and location of the incident</li>
                <li>Names and roles of those involved</li>
                <li>Detailed description of what happened</li>
                <li>Actions taken and by whom</li>
                <li>Witness statements (if applicable)</li>
                <li>Signatures and contact details</li>
            </ul>

            <h3>Best Practices for Writing Reports</h3>
            <ul>
                <li>Be clear, concise, and objective</li>
                <li>Use plain language and avoid jargon</li>
                <li>Stick to facts — avoid opinions or assumptions</li>
                <li>Write in chronological order</li>
                <li>Proofread for accuracy and completeness</li>
            </ul>

            <h3>Data Protection & Confidentiality</h3>
            <ul>
                <li>Store reports securely and limit access</li>
                <li>Comply with the UK GDPR and Data Protection Act 2018</li>
                <li>Do not share sensitive information without authorization</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> A customer becomes aggressive after being refused entry. You and a colleague escort them away without physical contact. Write a brief report including key details.
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.skillsforsecurity.org.uk/" target="_blank" rel="noreferrer">Skills for Security – Reporting Standards</a></li>
                <li><a href="https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/" target="_blank" rel="noreferrer">ICO – UK GDPR Guidance</a></li>
                <li><a href="https://www.gov.uk/data-protection" target="_blank" rel="noreferrer">UK Gov – Data Protection Overview</a></li>
            </ul>
        </div>
    );
}

export default DoorReporting;
